import { PanelProps } from "@mcleod/components";
import { LMEUserSettings } from "@mcleod/general";
import { MultiProfilePlanningTabs } from "@mcleod/dispatch/src/planning/MultiProfilePlanningTabs";
import { AutogenLayoutCarrierSalesBoardMultiProfile } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierSalesBoardMultiProfile";

export class CarrierSalesBoardMultiProfile extends AutogenLayoutCarrierSalesBoardMultiProfile  {
    private userProfiles: string[] = [];

    async onLoad(): Promise<void> {
        if (LMEUserSettings.get()?.carrier_call_list_id != null)
            this.userProfiles.push(LMEUserSettings.get().carrier_call_list_id);

        new MultiProfilePlanningTabs({
            tabset: this.tabsetCarrierSalesProfiles,
            profileDataSource: this.sourceCarrierSalesProfile,
            mainLayoutName: "lme/crm/CarrierSalesBoard",
            advancedFilterLayout: "lme/crm/CarrierSalesProfileFilter",
            startingProfiles: this.userProfiles,
            profileDescrFieldName: "descr"
        });
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
